import { AfterViewInit, Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TourService } from './tour.service';

@Component({
  selector: 'app-tour',
  imports: [DialogModule, NgClass, ButtonModule],
  templateUrl: './tour.component.html',
  standalone: true,
})
export class TourComponent implements AfterViewInit {
  // Emite el tour de la dashboard
  @Output() dashboardTour = new EventEmitter<void>();
  @Output() vehiculoTour = new EventEmitter<void>();
  @Output() movimientosTour = new EventEmitter<void>();

  router = inject(Router);
  tourService = inject(TourService);
  visible = false;

  constructor() {}

  ngAfterViewInit() {
    // Inicia el tour automático si estamos en el dashboard
    //this.tourService.startAutoTourOnDashboard();
    this.waitForElementAndInitDriver();

    // Suscribirse a los eventos para mostrar el modal de confirmación
    this.dashboardTour.subscribe(() => {
      this.tourService.startDashboardTour();
      this.visible = false;
    });

    this.vehiculoTour.subscribe(() => {
      this.tourService.startVehiculoTour();
    });

    this.movimientosTour.subscribe(() => {
      this.tourService.startMovimientosTour();
    });

    // Escuchar cuando los tours se completan
    this.tourService.tourCompleted$.subscribe((tourType) => {
      tourType.driverObj.destroy();
      localStorage.setItem('show_tour', 'false');
    });
  }

  startTour() {
    this.visible = false;
    this.tourService.startDashboardTour();
  }

  closeModal() {
    localStorage.setItem('show_tour', 'false');
    this.visible = false;
  }

  /**
   * Método para mostrar el modal de confirmación del tour
   */
  private waitForElementAndInitDriver() {
    const checkElement = () => {
      const element = document.querySelector('.tour-ultimos-movimientos');
      if (element) {
        // El elemento existe, mostrar modal de confirmación
        if (localStorage.getItem('show_tour') === 'true' || localStorage.getItem('show_tour') === null) {
          this.visible = true;
        }
      } else {
        // El elemento no existe aún, esperar un poco más
        setTimeout(checkElement, 100);
      }
    };

    // Comenzar la verificación después de un pequeño delay
    setTimeout(checkElement, 200);
  }
}
